import React, { useEffect } from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import { useSelector, useDispatch } from "react-redux";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import Prize from "@jumbo/Dashboards/PointShop/Prize";

import { useParams } from "react-router";
import NewsRequests from "services/news";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.pointShop"} />, link: "/pointShop" },
  { label: <IntlMessages id={"pages.prizeDetails"} />, isActive: true },
];

const PrizeDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { prize } = useSelector(({ news }) => news);

  useEffect(() => {
    dispatch(NewsRequests.getSinglePrize(id));
  }, []);

  return (
    <PageContainer
      heading={<IntlMessages id="pages.prizeDetails" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <Divider />
          <div style={{ marginTop: 24 }}>
            {prize && <Prize prize={prize} />}
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default PrizeDetails;
